import StrollerListDesktop from './StrollerListDesktop/StrollerListDesktop';
import StrollerListMobile from './StrollerListMobile/StrollerListMobile';
import { isMobile } from 'utils/isMobile';

export default isMobile ? StrollerListMobile : StrollerListDesktop;
